import { useRef, useLayoutEffect } from "react";

const refs = new Map();

const handleMessage = (event) => {
 // console.log(event);
    if (event.origin !== "https://socializace.asocialove.cz") return;
    if (event.data?.type !== "SET_HEIGHT") return;

    const ref = refs.get(event.data.form);
    if (ref?.current) {
        ref.current.style.height = event.data.height + "px";
    }
};

const sendGetHeight = () => {
    for (const [form, ref] of refs) {
        if (ref.current?.contentWindow) {
            ref.current.contentWindow.postMessage(
                { type: "GET_HEIGHT", form },
                "https://socializace.asocialove.cz"
            );
        }
    }
};

let listenerCount = 0;
let intervalId = null;

export function useIFrameHeight(form) {
    const iframeRef = useRef(null);

    useLayoutEffect(() => {
        refs.set(form, iframeRef);
        listenerCount++;

        if (listenerCount === 1) {
            window.addEventListener("message", handleMessage);
            window.addEventListener("resize", sendGetHeight);
            intervalId = setInterval(sendGetHeight, 1000);
        }

        sendGetHeight();

        return () => {
            refs.delete(form);
            listenerCount--;

            if (listenerCount === 0) {
                window.removeEventListener("message", handleMessage);
                window.removeEventListener("resize", sendGetHeight);
                clearInterval(intervalId);
                intervalId = null;
            }
        };
    }, [form]);

    return iframeRef;
}
